import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/** @see docs/API_SYSTEM_USER.md */
export async function fetchUserList(listQuery) {
  const { data: raw } = await request.get('/system/user', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
